module.exports = __webpack_public_path__ + "img/logotyp_skala_szarosci_bez_lat.c688d6fe.jpg";